import React, { useState } from "react";
import {Button, Modal} from "semantic-ui-react";
import Draggable from 'react-draggable'
import './entryStatusModalStyle.scss'
import CommonFieldsMock from "./mockComponents/CommonFieldsMock.js";
import ExportFieldsMock from "./mockComponents/export/ExportFieldsMock.js";
import AESExportMock from "./mockComponents/export/AESExportMock";
import {BOX40Accept, BOX44Accept, mockCancel, PDCAccept, cancelAccepted, PDCAmendAccept, exportMock,AESMockServicecall} from "../../components/ES_App/api/mockAPIEvents.js"
import { object } from "prop-types";
import _ from "lodash";

const UpdateResponseEntry = ({shipmentId, buttonTitle, ESCustomState, propMRN, formType, serviceType,version}) => {
    const reference = React.useRef(null);
    const expReference = React.useRef(null);
    const [open, setOpen] = React.useState(false);
    const [submitTxt, setSubmitTxt] = React.useState("Submit");
    const [aesData,setAesData] = React.useState({})
    const [entryStatusErr, setEntryStatusErr] = React.useState("")
    const [entryStatusSuccess, setEntryStatusSuccess] = React.useState("")
    const [mandErr, setMandErr] = React.useState(false)
    const displayMsgs = (response) => {
        let flag = 1;
        if(_.get(response, "data.eventMessage.code") === 200){
            setEntryStatusSuccess(_.get(response, "data.eventMessage.msg"));
        }
        else if(_.get(response, "data.eventMessage.message")){
            setEntryStatusErr("Data Cannot be Updated, Try Again Later!");
            flag = 0;
        }
        else{
            setEntryStatusErr(_.get(response, "data.eventMessage.msg"));
            flag = 0;
        }
        setTimeout(() => {
            setEntryStatusSuccess("");
            setEntryStatusErr("");
            setSubmitTxt("Submit")
            if(flag)
                setOpen(false)
        }, 2000)
    }

    const submitHandler = () =>{
        setSubmitTxt("Sumbitting...")
        if((serviceType === "EXPORT" && version === "AES")){
            if(!aesData.responseCode || !aesData.aesStatus || !aesData.circuit){
                setMandErr(true);
                setSubmitTxt("Submit")
                return false;
            }
            else {
                setMandErr(false);
            AESMockServicecall(shipmentId,aesData.responseCode,formType,aesData.aesStatus,aesData.circuit).then((response) => {
                displayMsgs(response);
            }).catch((err) => {
                console.log(err);
            })
            return}
        }
        const data = serviceType === "IMPORT" ? reference.current?.getUpdateResponseData() : expReference.current?.getUpdateResponseData();
        console.log("export data: ", data);
        let error = false;
        setMandErr(false);
        if(formType === "PDC" || formType === "Cancel"){
            data.common.circuit = undefined;
        }
        if(formType === "Cancel"){
            data.common.responseCode = undefined;
        }
        if(data.common.responseCode === "0" || serviceType == "EXPORT"){
            for(let element of Object.keys(data)){
                if(data[element] !== undefined){
                    let dataVal = Object.values(data[element]);
                    for(let val of dataVal){
                        console.log("value: ", val);
                        if(val === ""){
                            error = true;
                            break;
                        }
                    }
                    if(error){
                        break;
                    }
                }
            };
        }
        else if(formType !== "Cancel" && serviceType === "IMPORT"){
            let dataVal = Object.values(data["error"]);
            for(let val of dataVal){
                if(val === ""){
                    error = true;
                    break;
                }
            }
        }
        if(error){
            setMandErr(true);
            setSubmitTxt("Submit")
            return false;
        }
        let eventType = "";
        if(serviceType === "IMPORT"){
            if(data.common.responseCode === "9"){
                if(formType === "Cancel"){
                    cancelAccepted("").then((response) => {
                        displayMsgs(response)
                    }).catch((err) => {
                        console.log(err)
                    })
                }
                else{
                    mockCancel(shipmentId, data.common.responseCode, data.error.errorCode, data.error.errorDescription, data.error.errorItemNumber,
                        data.error.errorItemOrderNumber, data.error.errorLabel, data.error.errorValue, formType).then((response) => {
                            displayMsgs(response)
                        }).catch((err) => {
                            console.log(err);
                        })
                }
            }
            else{
                if(formType === "PDC" || formType === "FullSad"){
                    PDCAccept(shipmentId, data.common.responseCode, data.PDC.oppCode, data.common.circuit, data.common.MRN, formType).then((response) => {
                        displayMsgs(response)
                    }).catch((err) => {
                        console.log(err)
                    })
                }
                if(formType === "Box40"){
                    eventType = "MOCK_BOX_40"
                    BOX40Accept(shipmentId, data.common.responseCode, data.box40.requireCertificate, data.common.circuit, data.common.MRN).then((response) => {
                        displayMsgs(response)
                    }).catch((err) => {
                        console.log(err)
                    })
                }
                if(formType === "Box44"){
                    eventType = "MOCK_BOX_44"
                    BOX44Accept(shipmentId, data.common.responseCode, data.box44.dispatchStatus, data.box44.accountingStatus, data.common.circuit, data.common.MRN, data.box44.releaseIndicator).then((response) => {
                        displayMsgs(response)
                    }).catch((err) => {
                        console.log(err)
                    })
                }
                if(formType === "Cancel"){
                    eventType = "MOCK_PDC"
                    cancelAccepted(shipmentId, data.common.MRN).then((response) => {
                        displayMsgs(response)
                    }).catch((err) => {
                        console.log(err)
                    })
                }
                if(formType === "PdcAmend"){
                    eventType = "MOCK_PDC_AMEND"
                    PDCAmendAccept(shipmentId, data.common.responseCode, data.PDC.oppCode, data.common.circuit, data.common.MRN, data.box40.requireCertificate).then((response) => {
                        displayMsgs(response);
                    }).catch((err) => {
                        console.log(err)
                    })
                }
            }
        }
        else{
             exportMock(shipmentId, data.common.processIndicator, data.common.MRN, data.common.acceptanceDate === "" ? undefined : data.common.acceptanceDate, data.errorMock !== undefined ? data.errorMock : data.indicator4 !== undefined ? data.indicator4 : {}).then((response) => {
                displayMsgs(response);
            }).catch((err) => {
                console.log(err);
            })
            
        }
    }

    const updateResponseClickHandler = () => {
    }
    return (
      <Draggable handle='.header'>
        <Modal
          size='small'
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          open={open}
          trigger={
            <Button
              size='mini'
              key='UPDATE_RESPONSE'
              disabled={false}
              className='sv todo-button primaryBtn'
              onClick={(e) => {
                e.stopPropagation()
                updateResponseClickHandler()
              }}
            >
              {buttonTitle}
            </Button>
          }
        >
          <Modal.Header className='entry-modal-header'>Update Response: {shipmentId}</Modal.Header>
          <Modal.Content className='entry-status-modal-content'>
            {entryStatusErr && (
              <div className='error-div'>
                <h5>{entryStatusErr}</h5>
              </div>
            )}
            {entryStatusSuccess && (
              <div className='success-div'>
                <h5>{entryStatusSuccess}</h5>
              </div>
            )}
            {mandErr && (
              <div className='mand-error-div'>
                <h5>* All Fields are Mandatory</h5>
              </div>
            )}
            {serviceType === 'IMPORT' && (
              <CommonFieldsMock reference={reference} propMRN={propMRN} formType={formType} />
            )}
            
            {serviceType === 'EXPORT' &&
              (version !== 'AES' ? (
                <ExportFieldsMock reference={expReference} propMRN={propMRN} />
              ) : (
                <AESExportMock setAesData={setAesData} formType={formType} />
              ))}
          </Modal.Content>
          <Modal.Actions>
            <Button color='blue' onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button positive onClick={() => submitHandler()}>
              {submitTxt}
            </Button>
          </Modal.Actions>
        </Modal>
      </Draggable>
    )
}

export default UpdateResponseEntry;